export const DAILY_INTERVAL = "daily"
export const WEEKLY_INTERVAL = "weekly"
export const MONTHLY_INTERVAL = "monthly"
